import { render } from "./BasicCheckbox.vue?vue&type=template&id=c1ff8430&scoped=true"
import script from "./BasicCheckbox.vue?vue&type=script&lang=js"
export * from "./BasicCheckbox.vue?vue&type=script&lang=js"

import "./BasicCheckbox.vue?vue&type=style&index=0&id=c1ff8430&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-c1ff8430"

export default script